import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.754 7.307L18.26 8.8 15.2 5.74l1.493-1.494a.794.794 0 0 1 1.15 0l1.91 1.911a.794.794 0 0 1 0 1.15zM4 16.55L14.167 6.4 17.6 9.833 7.45 20H4v-3.45z"
  }));
});